import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ProspectDto } from '@shared/models/prospect';

@Injectable({ providedIn: 'root' })
export class ProspectService extends ApiService<ProspectDto> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'prospect/';
  }
}
